import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const CreditsContext = createContext();

export const CreditsProvider = ({ children }) => {
  const [credits, setCredits] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCredits = async () => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');

    if (userId && token) {
      setIsLoading(true);
      try {
        const cleanToken = token.replace(/"/g, '');
        const config = {
          headers: {
            Authorization: `Bearer ${cleanToken}`,
          },
        };
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/getWalletBalance?userId=${userId}`,
          config
        );
        setCredits(response.data.balance); // Assuming API response has a 'balance' field
      } catch (error) {
        console.error('Error fetching credits:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  return (
    <CreditsContext.Provider value={{ credits, isLoading, fetchCredits }}>
      {children}
    </CreditsContext.Provider>
  );
};

CreditsProvider.propTypes = {
  children: PropTypes.node.isRequired, 
};


export const useCredits = () => useContext(CreditsContext);
